module.exports = __webpack_public_path__ + "img/logo.211ffd34.png";